import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <manage-permissions-users-filter
            list="vm.list"
            default-filter="vm.defaultFilter"
            filter="vm.filter"
            has-active-users="vm.hasActiveUsers"
        />
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table
                class="data01"
                ng-init="vm.initBulk()"
                datatable
                dt-options="vm.DATATABLES">
                <thead>
                <tr>
                    <th class="w1p">
                        <input ng-if="vm.hasActiveUsers" ng-click="vm.toggleAll()" ng-model="vm.checked" type="checkbox">
                    </th>
                    <th ng-class="vm.list.getSortClass('displayName')"><a ng-click="vm.list.sortBy('displayName')">{{ 'user.Name' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('isExternalAccountActivated')">
                        <a ng-click="vm.list.sortBy('isExternalAccountActivated')">{{ 'user.Account activated' | translate }}</a>
                    </th>
                    <th ng-class="vm.list.getSortClass('status')">
                        <a ng-click="vm.list.sortBy('status')">{{ 'user.Employment status' | translate }}</a>
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>
                            <input ng-if="vm.UserService.isActive(item)" type="checkbox"
                            ng-checked="vm.hasUser(item.id)" ng-click="$event.stopPropagation();vm.toggleUser(item.id)">
                        </td>
                        <td><a ui-sref="authorized.manage.permissions.users.detail.sites({ id: item.id })">{{ item.displayName }}</a></td>
                        <td>
                            <span ng-if="item.isExternalAccountActivated">{{ 'general.Yes' | translate }}</span>
                                <span ng-if="!item.isExternalAccountActivated &&
                                !item.isExternalAccountActivationEmailSent">{{ 'general.No' | translate }}</span>
                                <span
                                    ng-if="!item.isExternalAccountActivated
                                    && item.isExternalAccountActivationEmailSent
                                    && item.isValidExternalActivationLink"
                                >
                                    {{ 'user.No' | translate }}<br/>
                                    <small>{{ 'user.Email sent on' | translate }} {{ vm.MomentService.formatTimeStamp(item.externalAccountActivationEmailSentAt) }}</small>
                                </span>
                                <span
                                    ng-if="!item.isExternalAccountActivated
                                    && item.isExternalAccountActivationEmailSent
                                    && !item.isValidExternalActivationLink"
                                >
                                    {{ 'user.No' | translate }}<br/>
                                    <small>{{ 'user.E-mail link inactive' | translate }}</small>
                                </span>
                        </td>
                        <td>{{ vm.UserService.getStatusLabel(item) }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
        <user-bulk
            ng-if="!vm.list.loading && vm.hasActiveUsers"
            list="vm.list"
            user-ids="vm.userIds"
            filter="vm.filter"
        />
    `
})
export default class {
    constructor (lodash, DATATABLES, ListFactory, UserResource, UserService, USER_STATUS_ENUM, MomentService) {
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.UserResource = UserResource;
        this.UserService = UserService;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.MomentService = MomentService;
    }

    $onInit () {
        this.userIds = [];
        this.defaultFilter = { expand: 'roles,isValidExternalActivationLink' };
        this.filter = angular.copy(this.defaultFilter);
        this.list = this.ListFactory.createWithPagination(this.UserResource.query.bind(this.UserResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 50;
        this.list.fetch(this.defaultFilter).then((users) => {
            this.hasActiveUsers = users.filter((user) => this.UserService.isActive(user)).length;
        });
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
            this.checked = false;
        }
        else {
            this.userIds.push(key);
        }
    }

    toggleAll () {
        const activeUsers = this.list.items.filter((user) => this.UserService.isActive(user));
        this.userIds = this.checked ? activeUsers.map((user) => user.id) : [];
    }

    initBulk () {
        this.userIds = [];
        this.checked = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/users/list/all/index.js